import mirrorkey from 'mirrorkey';

export default mirrorkey([
    'CREATE_TIME_SLOT_REQUEST',
    'CREATE_TIME_SLOT_FAIL',
    'CREATE_TIME_SLOT_SUCCESS',
    'GET_SCHEDULE_DETAILS_REQUEST',
    'GET_SCHEDULE_DETAILS_FAIL',
    'GET_SCHEDULE_DETAILS_SUCCESS'
]);